export function getToken() {
  return localStorage.getItem('TOKEN');
}

export function removeToken() {
  return localStorage.removeItem('TOKEN');
}

